import React from 'react';
import { graphql } from "react-apollo";
import { Icon, Form, Button, Select } from 'antd';
import Spinner from '../../spinner/spinner';
import { updateChurchMemberGroup } from "./mutations/updateChurchMemberGroup";
const FormItem = Form.Item;

class EditableCell extends React.Component {
  constructor(props) {
    super(props);
    this.state = { editable: false };
  }

  onCancelClick = () => {
    this.setState({ editable: false });
  };

  onEditClick = () => {
    this.setState({ editable: true });
  };

  onSubmit = (event) => {
    event.preventDefault();

    this.submitData(this.mutationParams);
  };

  async submitData(params) {
    try {
      this.setState({ loading: true });
      await this.props.mutate(params);
    } finally {
      this.setState({ loading: false, editable: false });
    }
  }

  get mutationParams() {
    return {
      variables: {
        input: {
          id: this.props.churchMember.id,
          church_group_id: parseInt(this.props.form.getFieldValue('churchGroupId'), 10)
        }
      }
    };
  }

  render() {
    const { getFieldDecorator } = this.props.form;
    const { editable, loading } = this.state;

    if (editable) {
      return (
        <Form onSubmit={this.onSubmit} className="editable-cell">
          { loading && <Spinner/> }
          <div className="editable-cell-input-wrapper">
            <FormItem className="editable-cell__group-selector">
              {getFieldDecorator("churchGroupId", {
                initialValue: `${this.props.churchMember.groupId}`
              })(
                <Select className="church-members-table__group_filter" disabled={loading}>
                  {
                    this.props.groups.edges.map(edges => edges.node).map(group => {
                      return (
                        <Select.Option key={`church_group_id_${group.id}`} value={`${group.id}`}>
                          {group.name}
                        </Select.Option>
                      );
                    })
                  }
                </Select>
              )}
            </FormItem>
            <FormItem>
              <Button htmlType="submit" className="editable-cell-button-submit" disabled={loading}>
                <Icon type="check" className="editable-cell-icon-check"/>
              </Button>
            </FormItem>
            <FormItem>
              <Icon type="close" className="editable-cell-icon-cancel" onClick={this.onCancelClick}/>
            </FormItem>
          </div>
        </Form>
      );
    } else {
      return (
        <div className="editable-cell">
          <div className="editable-cell-text-wrapper">
            { this.props.value }
            <Icon type="edit" className="editable-cell-icon" onClick={this.onEditClick}/>
          </div>
        </div>
      );
    }
  }
}

export default Form.create()(graphql(updateChurchMemberGroup)(EditableCell));



// WEBPACK FOOTER //
// ./src/components/pages/churchMembers/editableCell.js